import React, { useEffect } from 'react';
import { Box, Container, Typography, Card, CardContent, Grid, Chip, Stack, Button } from '@mui/material';
import { Check, Business } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const FacturationPME = () => {
  const navigate = useNavigate();

  const goToRegisterTracked = () => {
    const params = new URLSearchParams({
      utm_source: 'site_facteio',
      utm_medium: 'cta',
      utm_campaign: 'facturation_pme',
      utm_content: 'cta_page'
    });
    navigate(`/register?${params.toString()}`);
  };

  useEffect(() => {
    document.title = 'Logiciel facturation PME | Facteio';
    const description = 'Facteio : logiciel facturation PME et solution facture électronique petite entreprise. Simple, clair, et prêt pour la réforme 2026.';
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('name', 'description');
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', description);
  }, []);

  return (
    <Box sx={(theme) => ({ background: theme.palette.background.default, minHeight: '100vh', py: 5 })}>
      <Container maxWidth="lg">
        <Button variant="text" onClick={() => navigate('/')} sx={{ mb: 2, fontWeight: 600 }}>
          ← Retour à l'accueil
        </Button>

        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="center" mb={2}>
          <Chip icon={<Business />} label="PME & petite entreprise" sx={{ bgcolor: '#E7DED4', color: '#1F2937' }} />
          <Chip icon={<Check />} label="Solution facture électronique" />
          <Chip icon={<Check />} label="Ciblage SEO petite entreprise" />
        </Stack>

        <Typography variant="h3" fontWeight={800} mb={1}>
          Logiciel facturation PME
        </Typography>
        <Typography variant="h6" color="text.secondary" mb={4}>
          Une solution de facture électronique pensée pour les petites entreprises : simple à prendre en main,
          structurée pour suivre vos clients, devis et factures, et prête pour 2026.
        </Typography>

        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Typography variant="h6" fontWeight={700} mb={2}>
                  Pour PME : plus de clarté au quotidien
                </Typography>
                <Typography>• Devis & factures centralisés</Typography>
                <Typography>• Suivi des clients et documents</Typography>
                <Typography>• Process simple, sans jargon</Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Typography variant="h6" fontWeight={700} mb={2}>
                  Petite entreprise : conformité sans complexité
                </Typography>
                <Typography>• Mentions essentielles cadrées</Typography>
                <Typography>• Préparation facture électronique 2026</Typography>
                <Typography>• Assistance et accompagnement si besoin</Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <Card sx={{ mt: 4, border: '1px solid #D5CDC3' }}>
          <CardContent sx={{ textAlign: 'center', py: 4 }}>
            <Typography variant="h5" fontWeight={800} mb={1}>
              Passez à une facturation plus simple
            </Typography>
            <Typography color="text.secondary" mb={2}>
              Testez Facteio pour votre PME ou petite entreprise : devis, factures, et préparation 2026.
            </Typography>
            <Button variant="contained" onClick={goToRegisterTracked}>
              Essayer Facteio pour PME
            </Button>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};

export default FacturationPME;
